export enum StorageProviderType {
  LOCAL = 'local',
  JSONBIN = 'jsonbin',
  GITHUB = 'github',
  GITLAB = 'gitlab',
  ADO = 'ado',
  URL = 'url',
  BITBUCKET = 'bitbucket',
}
